"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'userGroup.form.title.edit': 'Editar Grupo de Usuarios',
    'userGroup.form.title.add': 'Agregar Grupo de Usuarios',
    'userGroup.form.back': 'Volver',
    'userGroup.form.name.label': 'Nombre del Grupo',
    'userGroup.form.name.placeholder': 'Introducir nombre del grupo',
    'userGroup.form.description.label': 'Descripción',
    'userGroup.form.description.placeholder': 'Introducir descripción del grupo',
    'userGroup.form.active.label': 'Activo',
    'userGroup.form.acl.label': 'Control de Acceso',
    'userGroup.form.acl.description': 'Configurar permisos de acceso para este grupo de usuarios',
    'userGroup.form.submit.update': 'Actualizar Grupo de Usuarios',
    'userGroup.form.submit.create': 'Crear Grupo de Usuarios',
    'userGroup.form.saved': 'Grupo de usuarios guardado exitosamente',
    'userGroup.form.error.save': 'Error al guardar el grupo de usuarios',
};
